(function () {
  'use strict';
  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-collection]'));
  if (!roots.length) return;

  function send(name, params) {
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
  }

  function item(c) {
    return {
      item_id: c.getAttribute('data-product-id') || '',
      item_name: c.getAttribute('data-title') || '',
      item_handle: c.getAttribute('data-handle') || '',
      item_brand: 'Alatreyu',
      index: parseInt(c.getAttribute('data-position'), 10) || 0
    };
  }

  roots.forEach(function (root) {
    if (root.getAttribute('data-ga-bound')) return;
    root.setAttribute('data-ga-bound', '1');
    var listId = root.getAttribute('data-list-id') || '';
    var listName = root.getAttribute('data-list-name') || '';
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-position]'));
    if (!cards.length) return;
    send('view_item_list', { item_list_id: listId, item_list_name: listName, items: cards.slice(0, 25).map(item) });
    root.addEventListener('click', function (e) {
      var c = e.target.closest('[data-position]');
      if (!c || e.target.closest('[data-quick-pwyc], [data-quick-add]')) return;
      send('select_item', { item_list_id: listId, item_list_name: listName, items: [item(c)] });
    });
  });
})();
